<template>
  <v-hover v-slot="{ hover }">
    <div class="relative">
      <div class="absolute bottom-0 left-0 mb-n2 d-flex w-full align-end">
        <div v-for="(gender, i) in genders" :key="i">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                v-if="course.genders.includes(gender.name)"
                icon
                small
                style="z-index: 0"
                class="relative bottom-0 left-0"
                :color="gender.color"
              >
                <v-icon small :color="gender.color" class="text--lighten-1"
                  >mdi-tshirt-crew</v-icon
                >
              </v-btn>
            </template>
            <span>{{ $t(gender.name) }}</span>
          </v-tooltip>
        </div>
        <v-spacer></v-spacer>
        <div class="relative mb-1 grey--text text--darken-2 font-weight-medium">
          <span>{{ $t('age') }}:</span> {{course.age_from}} - {{course.age_to}}
        </div>
        <v-spacer></v-spacer>
        <div v-for="category in config.categories" :key="category.name">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                v-if="
                  course.categories.filter((cat) => cat.name === category.name)
                    .length > 0
                "
                icon
                style="z-index: 0"
                class="relative bottom-0 left-0"
                :color="category.color"
              >
                <v-icon class="text--lighten-1" :color="category.color">{{
                  category.icon
                }}</v-icon>
              </v-btn>
            </template>
            <span>{{ $t(category.name) }}</span>
          </v-tooltip>
        </div>
      </div>
      <div
        style="cursor: pointer; z-index: 4"
        v-ripple
        :class="{ elevate: hover }"
        class="trans"
      >
        <div
          class="px-3 mt-10 relative"
          style="background-color: #f5f7fa !important"
        >
          <v-img
            class="h-32 w-full object-cover trans mb-n14 offer-card"
            :class="hover ? 'elevation-8' : 'elevation-4'"
            :src="$connection + course.photoURL"
            :alt="course.title"
          >
            <template v-slot:placeholder>
              <v-row
                class="fill-height ma-0 grey lighten-2"
                align="center"
                justify="center"
              >
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                ></v-progress-circular>
              </v-row> </template
          ></v-img>

          <div class="absolute top-0 right-0 z-index-2 white">
            <v-tooltip v-if="course.info" left max-width="250">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="blue"
                  v-bind="attrs"
                  v-on="on"
                  style="background-color: white; border-radius: 9999px"
                  >mdi-information</v-icon
                >
              </template>
              <span>
                {{ course.info }}
              </span>
            </v-tooltip>
          </div>
        </div>
        <v-card
          tile
          class="text-center trans pt-16 pa-5"
          :class="hover ? 'elevation-10' : 'elevation-4'"
        >
          <div class="text-subtitle-1 font-weight-bold">{{ course.title }}</div>
          <div class="text-body-2 mt-2 ellipsis-4">
            {{ course.description }}
          </div>
        </v-card>
      </div>
    </div>
  </v-hover>
</template>

<script>
export default {
  props: ["course"],
  data() {
    return {
      genders: [
        { name: "männlich", color: "blue lighten-3" },
        { name: "weiblich", color: "pink lighten-3" },
        { name: "divers", color: "green lighten-3" },
      ],
    };
  },
  computed: {
    config() {
      return this.$store.getters["config/getConfig"];
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/main.scss";

.trans {
  transition: all 0.4s ease-in-out;
}

.elevate {
  transform: translateY(-40px);
}

.offer-card {
  z-index: 2;
  position: relative;
  border-radius: 2px;
}
</style>